<template>
    <div class="download--content">
        <div class="download--content-header">
            <header class="header-content">
                <div class="headline">
                    <button class="menu-toggler" @click="toggleResponsiveMenu()"><i class="icon-menu"></i></button>
                    <h2 class="heading">{{ labels.categories }}</h2>
                </div>
            </header>
            <div class="body">
                <div class="entries">
                    <div class="count--with-label"><span>{{ filteredItems.length }}</span>{{ labels.files }}</div>
                </div>
                <div class="search-input input-border-radius">
                    <input v-model="search">
                    <i class="icon-search"></i>
                </div>
                <div class="layout-switch">
                    <div class="btn--group">
                        <a :class="{ active: isGrid }" @click="changeLayout('grid', $event)"><i
                                class="icon-ui-grid"></i></a>
                        <a :class="{ active: !isGrid }" @click="changeLayout('list', $event)"><i
                                class="icon-ui-list"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="download--content-main">
            <div v-if="paginatedData.length == 0" class="info--box info-grey">
                {{ labels.empty }}
            </div>
            <div v-if="isGrid" class="grid col-custom-2">
                <div class="row row--dense-sm">
                    <div v-for="(item, i) in paginatedData" :key="`item-${i}`"
                        class="col-12 col-sm-6 col-md-4 col-xl-3 col-item">
                        <div class="download--item hover--shadow-transition">
                            <div class="image__container" @click="showLightbox(item)"
                                :class="{ 'is--icon': !item.isImage }">
                                <div :style="{ 'background-image': 'url(' + (item.isImage ? item.image : item.icon) + ')' }"
                                    class="image"></div>
                            </div>
                            <div class="content">
                                <div class="title">
                                    {{ item.title }}
                                </div>
                                <div class="date typo-sublabel">
                                    {{ item.date }}
                                </div>
                                <div class="type typo-sublabel">
                                    {{ item.type }}
                                </div>
                                <div class="action">
                                    <i class="icon-ui-download"></i>
                                </div>
                            </div>
                            <a :href="item.link" :download='item.fileName' target="_blank"></a>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!isGrid" class="list">
                <ul class="list-unstyled">
                    <li class="hover--shadow-transition" v-for="(item, i) in paginatedData" :key="`item-hover-${i}`">
                        <div class="image__container" @click="showLightbox(item)">
                            <div class="image" :style="{ backgroundImage: 'url(' + item.icon + ')' }"></div>
                        </div>
                        <div class="infos">
                            <div class="title item">
                                <span class="d-block text-truncate">
                                    {{ item.title }}
                                </span>
                            </div>
                            <div class="type item typo-sublabel">
                                {{ item.type }}
                            </div>
                            <div class="date item typo-sublabel">
                                {{ item.date }}
                            </div>
                        </div>

                        <div class="action item">
                            <i class="icon-ui-download"></i>
                        </div>
                        <a :href="item.link" target="_blank" :download='item.fileName'></a>
                    </li>
                </ul>
            </div>

            <pagination v-if="filteredItems.length > 0" :label-previous="labels.previous" :label-next="labels.next"
                :label-page="labels.page" :label-pagination="labels.of" :total-pages="totalPages"
                :total="filteredItems.length" :per-page="resultsPerPage" :current-page="currentPage"
                @page-changed="pageChanged"></pagination>
        </div>

        <vue-lightbox v-model="lightbox.index" :images="lightbox.items">
        </vue-lightbox>
    </div>
</template>
<script>
import Pagination from './Pagination.vue';
import VueLightbox from './VueLightbox.vue';

export default {
    name: 'DownloadContent',
    props: {
        items: [Object, Array],
        labels: Object,
        defaultView: {
            type: String,
            default: 'grid'
        },
    },
    components: {
        Pagination,
        VueLightbox
    },
    data: () => ({
        isGrid: true,
        search: '',
        currentPage: 1,
        resultsPerPage: 20,
        lightbox: {
            index: undefined,
            items: [],
        }
    }),
    computed: {
        filteredItems() {
            if (!this.search.length) return this.items;
            return this.items.filter(item => {
                return item.title.toLowerCase().includes(this.search.toLowerCase())
            });
        },
        paginatedData() {
            if (!this.filteredItems.length) return [];

            const start = (this.currentPage - 1) * this.resultsPerPage;
            const end = start + this.resultsPerPage;

            let items = this.filteredItems.slice(start, end);
            this.setLightboxItems(items);
            return items;
        },
        totalPages() {
            return Math.ceil(this.filteredItems.length / this.resultsPerPage);
        },
    },
    watch: {
        search() {
            this.currentPage = 1;
        },
        items() {
            this.currentPage = 1;
        }
    },
    methods: {
        showLightbox(item) {
            if (item.isImage) {
                this.lightbox.index = this.lightbox.items.findIndex((i) => i.id === item.id);
            }
        },
        setLightboxItems(items) {
            this.lightbox.items = items.filter((i) => i.isImage);
        },
        toggleResponsiveMenu() {
            this.$emit('toggle-menu');
        },
        changeLayout(type, e) {
            e.preventDefault();
            this.isGrid = 'grid' === type;
        },
        pageChanged(page) {
            this.currentPage = page;
            const element = document.querySelector(".download--content");
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    },
    mounted() {
        this.isGrid = 'grid' === this.defaultView;
    }
}
</script>